import { Box, Card, Paper, PaperProps } from '@mantine/core';
import { CSSProperties, ReactNode, useState } from 'react';
import { cardRadius, clickableColor } from '../../mantineReactTable/sizes';
import React from 'react'
interface CustomCardProps {
  shadow?: string;
  padding?: string;
  radius?: string;
  withBorder?: boolean;
  children?: ReactNode;
  mb?: number;
  mt?: number | string;
  ml?: number;
  mr?: number
  w?: string | number;
  bg?: string;
  pt?: string | number;
  height?: string | number;
  isCustomRadius?: boolean;
  isFailed?: boolean;
  style?: CSSProperties;
  className?: string;
  hoverBorderColor?: string;
  onClick?:() => void;
}

const CustomCard = ({ shadow = '', padding = 'md', radius, withBorder = true, children, mb = 15, mt = 5, ml = 0, mr = 0, bg, w, pt, height, isCustomRadius = false, isFailed, style, className, hoverBorderColor, onClick }: CustomCardProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const cardStyle: CSSProperties = {
    ...(isFailed ? { border: '2px solid red' } : {}),
    border: hoverBorderColor ? `1px solid ${isHovered ? hoverBorderColor : 'transparent'}` : undefined,
    transition: hoverBorderColor ? 'border-color 0.2s ease' : undefined,
    ...style,
  };
  return (
    <Card shadow={shadow} padding={padding} radius={isCustomRadius ? radius : cardRadius} withBorder={withBorder} mb={mb} mt={mt} ml={ml} mr={mr} bg={bg} w={w} pt={pt} h={height} style={cardStyle} className={className} onClick={onClick} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      {children}
    </Card>
  );
};
export default CustomCard;




type HoverPaperProps = PaperProps & {
  children?: ReactNode;

  enableHover?: boolean;

  isHovered?: boolean;
  onHoverStart?: () => void;
  onHoverEnd?: () => void;

  p?: number;
  marginTop?: number;
  marginBottom?: number;
  width?: string | number;

  bgColor?: string;
  borderColor?: string;

  borderRadius?: string | number;
  boxShadow?: string;

  backdropFilter?: string;
  webkitBackdropFilter?: string;

  transition?: string;
  overflow?: string;
  position?: React.CSSProperties['position'];
  initialTransform?: string;

  hoverShadow?: string;
  hoverBorderColor?: string;
  hoverTransform?: string;

  isTopBorder?: boolean;
  topBorderColor?: string;
  topBorderHeight?: number;
  isDashedBorder?: boolean;
  dashedBorderColor?: string;
  dashedBorderWidth?: number;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  isClickable?: boolean;
  backgroundImage?: string;
  isDashboardView?: boolean;
};

export function PaperCard({
  children,

  enableHover = true,

  onHoverStart,
  onHoverEnd,

  p = 28,
  marginTop = 12.5,
  marginBottom = 25,
  width = '100%',
  backgroundImage,
  bgColor = 'rgba(255, 255, 255, 0.7)',
  borderColor = 'rgba(255, 255, 255, 0.4)',

  borderRadius = '2.5rem',
  boxShadow = '0 32px 64px rgba(0, 0, 0, 0.08)',

  backdropFilter = 'blur(40px)',
  webkitBackdropFilter = 'blur(40px)',

  transition = 'transform 0.5s ease, box-shadow 0.5s ease, border-color 0.5s ease',

  overflow = 'hidden',
  position = 'relative',
  initialTransform = 'translateY(0)',

  hoverShadow = '0 40px 80px rgba(0, 0, 0, 0.12)',
  hoverBorderColor = 'rgba(59, 130, 246, 0.5)',
  hoverTransform = 'translateY(-3px)',

  isTopBorder = false,
  topBorderColor = '#3b82f6',
  topBorderHeight = 7,

  isDashedBorder = false,
  dashedBorderColor = clickableColor,
  dashedBorderWidth = 0.5,

  onClick,
  isClickable = true,
  isDashboardView = false,

  style,
  ...rest
}: HoverPaperProps) {
  const handleEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!enableHover) return;

    onHoverStart?.();

    const el = e.currentTarget as HTMLElement;

    el.style.boxShadow = isDashboardView ? '0 32px 64px rgba(0,0,0,0.08)' : hoverShadow;
    el.style.transform = hoverTransform;

    if (isDashedBorder) {
      el.style.border = `${dashedBorderWidth}px dashed ${dashedBorderColor}`;
    } else {
      el.style.borderColor = hoverBorderColor;
    }
  };

  const handleLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!enableHover) return;

    onHoverEnd?.();

    const el = e.currentTarget as HTMLElement;

    el.style.boxShadow = boxShadow;
    el.style.transform = initialTransform;

    el.style.border = `${dashedBorderWidth}px solid ${borderColor}`;
  };

  return (
    <Paper
      p={p}
      mt={marginTop}
      mb={marginBottom}
      w={isDashboardView ? '380px' : width}
      onClick={onClick}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      style={{
        backgroundColor: bgColor,

        // IMPORTANT: always set initial border (prevents flicker)
        border: `${dashedBorderWidth}px solid ${borderColor}`,

        borderRadius,
        boxShadow,
        backdropFilter,
        WebkitBackdropFilter: webkitBackdropFilter,
        backgroundImage: backgroundImage,
        transition,
        overflow,
        position,
        transform: initialTransform,

        cursor: isClickable && onClick ? 'pointer' : 'default',

        paddingTop: isTopBorder ? p + topBorderHeight : p,

        ...style,
      }}
      {...rest}
    >
      {/* TOP BORDER */}
      {isTopBorder && (
        <Box
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: topBorderHeight,
            background: topBorderColor,
          }}
        />
      )}

      {children}
    </Paper>
  );
}
